import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
import BaseCustomElement from '../core/BaseCustomElement.js';

const MOBILE_BREAKPOINT = 1024;

export default class PipefyCardSlider extends BaseCustomElement {
  static tagName = 'pipefy-card-slider';

  constructor() {
    super();
    this.swiper = null;
    this.sliderEl = null;
    this.paginationEl = null;
    this.prevEl = null;
    this.nextEl = null;
    this.cardsCount = 0;
    this.resizeObserver = null;
  }

  isMobile() {
    return (
      typeof window !== 'undefined' &&
      window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches
    );
  }

  /** Slider when: more than 3 cards (any viewport), or 2+ cards on mobile */
  shouldUseSlider() {
    return this.cardsCount > 3 || (this.cardsCount >= 2 && this.isMobile());
  }

  init() {
    this.sliderEl = this.querySelector('.slider.swiper');
    this.paginationEl = this.querySelector('.pagination');
    this.prevEl = this.querySelector('.btn-prev');
    this.nextEl = this.querySelector('.btn-next');
    this.cardsCount = Number(this.dataset.cardsCount ?? 0);

    if (this.cardsCount <= 1 || !this.sliderEl) return;

    this.updateSlider();
    this.resizeObserver = new ResizeObserver(() => this.onResize());
    this.resizeObserver.observe(this);
  }

  onResize() {
    if (this.cardsCount <= 1 || this.cardsCount > 3) return;
    this.updateSlider();
  }

  updateSlider() {
    if (this.shouldUseSlider()) {
      if (!this.swiper) this.initSwiper();
    } else {
      if (this.swiper) this.destroySwiper();
    }
  }

  initSwiper() {
    if (this.swiper) return;
    this.swiper = new Swiper(this.sliderEl, {
      modules: [Pagination, Navigation],
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      pagination: this.paginationEl
        ? {
            el: this.paginationEl,
            type: 'bullets',
            clickable: true,
            dynamicBullets: true,
            dynamicMainBullets: 3,
          }
        : false,
      navigation: {
        prevEl: this.prevEl,
        nextEl: this.nextEl,
        disabledClass: 'btn-disabled',
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        [MOBILE_BREAKPOINT]: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    });
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.resizeObserver = null;
    this.destroySwiper();
  }
}

BaseCustomElement.register(PipefyCardSlider);
